/* SnapToonify Canada: six portrait products, scoped to approved handles. */
(function () {
  'use strict';
  const handles = new Set(['add-a-loved-one-to-a-photo', 'family-portrait-add-loved-one', 'custom-couple-painting-from-two-photos', 'bridesmaid-portrait-from-photos', 'groomsmen-portrait-from-photos', 'grandparents-and-grandchildren-portrait-from-photos', 'together-couple-portrait-from-two-photos']);
  const handle = location.pathname.toLowerCase().split('/products/')[1]?.split('/')[0];
  if (!handles.has(handle) || typeof CustomifyEmbed === 'undefined') return;
  const proto = CustomifyEmbed.prototype;
  const previousConfig = proto.getCustomFieldConfig;
  // The Canada theme predates the USA instance translation helper.
  if (typeof proto.t !== 'function') proto.t = function (key) {
    const fallback = {'customizer.personalization.title':'Personalization','customizer.error.image_file':'Choose an image file (JPG, PNG)','customizer.error.file_too_large':'File is too large (max 10MB)'};
    const translated = window.CustomifyI18n?.t?.(key);
    return translated && translated !== key ? translated : (fallback[key] || key);
  };
  const replacements = {
  isFamilyGrandparentsPilot() {
    return ['grandparents-and-grandchildren-portrait-from-photos', 'grosseltern-enkel-familienportraet-aus-fotos'].includes(this.getProductHandle());
  },

  usesFamilyPhotoCrop() {
    return ['grandparents-and-grandchildren-portrait-from-photos', 'grosseltern-enkel-familienportraet-aus-fotos', 'family-portrait-add-loved-one', 'add-a-loved-one-to-a-photo', 'personalisiertes-familienportraet-aus-mehreren-fotos'].includes(this.getProductHandle());
  },

  /** Zwraca config pól dla bieżącego produktu lub null */
  getCustomFieldConfig() {
    if (['custom-couple-painting-from-two-photos', 'personalisiertes-paarportraet-aus-zwei-fotos'].includes(this.getProductHandle())) {
      const isGerman = this.getProductHandle() === 'personalisiertes-paarportraet-aus-zwei-fotos';
      const copy = (en, de) => isGerman ? de : en;
      return {
        multiUpload: true,
        minImages: 2,
        maxImages: 6,
        fields: [
          { id: 'couple_art_style', label: copy('Choose your art style', 'Kunststil wählen'), type: 'family-select', defaultValue: 'watercolor', options: [
            ['sketch', copy('Sketch', 'Skizze')],
            ['watercolor', copy('Watercolor', 'Aquarell')],
            ['oil', copy('Oil Painting', 'Ölgemälde')]
          ] },
          { id: 'together_scene', label: copy('Choose your scene', 'Szene wählen'), type: 'family-select', defaultValue: 'classic', options: [
            ['classic', copy('Classic portrait', 'Klassisches Porträt')],
            ['sunset', copy('Sunset walk', 'Spaziergang bei Sonnenuntergang')],
            ['evening', copy('Elegant evening', 'Eleganter Abend')]
          ] },
          { id: 'scena', label: copy('Additional wishes (optional)', 'Zusätzliche Wünsche (optional)'), type: 'text', placeholder: copy('e.g. our favorite beach, relaxed clothing, a gentle embrace', 'z. B. unser Lieblingsstrand, legere Kleidung, eine liebevolle Umarmung') },
          { id: 'dedykacja', label: copy('Names, date or dedication (optional)', 'Namen, Datum oder Widmung (optional)'), type: 'text', maxLength: 120, placeholder: copy('e.g. Emma & James — Together, always', 'z. B. Emma & James – Für immer zusammen') }
        ]
      };
    }
    if (this.getProductHandle() === 'together-couple-portrait-from-two-photos') {
      return {
        multiUpload: true,
        minImages: 2,
        maxImages: 6,
        fields: [
          { id: 'family_background', label: 'Choose your background', type: 'family-select', defaultValue: 'studio', options: [
            ['photo', 'From your first photo'], ['studio', 'Bright studio'], ['home', 'Cozy home'], ['garden', 'Sunset garden'], ['custom', 'Your own idea']
          ] },
          { id: 'family_background_desc', label: 'Describe your background', type: 'text', maxLength: 1000, placeholder: 'e.g. our favorite beach at sunset', showWhen: { id: 'family_background', value: 'custom' } },
          { id: 'family_style', label: 'Choose your portrait style', type: 'family-select', defaultValue: 'photo', options: [
            ['photo', 'Natural photo'], ['watercolor', 'Soft watercolor'], ['oil', 'Classic oil painting'], ['sketch', 'Sketch']
          ] },
          { id: 'family_clothing', label: 'Choose your outfits', type: 'family-select', defaultValue: 'original', options: [
            ['original', 'Keep outfits from photos'], ['casual', 'Coordinated casual outfits'], ['elegant', 'Coordinated elegant outfits']
          ] },
          { id: 'scena', label: 'People arrangement & requests (optional)', type: 'text', placeholder: 'e.g. Person 1 on the left. Keep the wedding dress.' },
          { id: 'dedykacja', label: 'Names, date or dedication (optional)', type: 'text', maxLength: 120, placeholder: 'e.g. Emma & James — Together, always' }
        ]
      };
    }
    if (this.getProductHandle() === 'personalisierte-paar-karikatur-vom-foto') {
      return PRODUCT_FIELD_CONFIGS['personalisierte-paar-karikatur-vom-foto'];
    }
    if (['grandparents-and-grandchildren-portrait-from-photos', 'grosseltern-enkel-familienportraet-aus-fotos'].includes(this.getProductHandle())) {
      const isGerman = this.getProductHandle() === 'grosseltern-enkel-familienportraet-aus-fotos';
      const copy = (en, de) => isGerman ? de : en;
      return {
        multiUpload: true,
        minImages: 1,
        maxImages: 6,
        fields: [
          { id: 'family_background', label: copy('Choose your background', 'Hintergrund wählen'), type: 'family-select', defaultValue: 'studio', options: [
            ['photo', copy('From your first photo', 'Aus deinem ersten Foto')], ['studio', copy('Bright studio', 'Helles Studio')], ['home', copy('Cozy home', 'Gemütliches Zuhause')], ['garden', copy('Sunset garden', 'Garten bei Sonnenuntergang')], ['custom', copy('Your own idea', 'Eigene Idee')]
          ] },
          { id: 'family_background_desc', label: copy('Describe your background', 'Hintergrund beschreiben'), type: 'text', maxLength: 1000, placeholder: copy('e.g. our favorite beach at sunset', 'z. B. unser Lieblingsstrand bei Sonnenuntergang'), showWhen: { id: 'family_background', value: 'custom' } },
          { id: 'family_style', label: copy('Choose your portrait style', 'Porträtstil wählen'), type: 'family-select', defaultValue: 'photo', options: [
            ['photo', copy('Natural photo', 'Natürliches Foto')], ['watercolor', copy('Soft watercolor', 'Zartes Aquarell')], ['oil', copy('Classic oil painting', 'Klassisches Ölgemälde')], ['sketch', copy('Sketch', 'Skizze')]
          ] },
          { id: 'family_clothing', label: copy('Choose your outfits', 'Kleidung wählen'), type: 'family-select', defaultValue: 'original', options: [
            ['original', copy('Keep outfits from photos', 'Kleidung aus den Fotos beibehalten')], ['casual', copy('Coordinated casual outfits', 'Abgestimmte Freizeitkleidung')], ['elegant', copy('Coordinated elegant outfits', 'Abgestimmte elegante Kleidung')]
          ] },
          { id: 'scena', label: copy('People arrangement & requests (optional)', 'Anordnung und Wünsche (optional)'), type: 'text', placeholder: copy('Left to right: Grandma, children, Grandpa. Keep Grandpa’s uniform.', 'Von links nach rechts: Oma, Kinder, Opa. Opas Uniform beibehalten.') },
          { id: 'dedykacja', label: copy('Signature or dedication (optional)', 'Unterschrift oder Widmung (optional)'), type: 'text', placeholder: copy('e.g. Together, always', 'z. B. Für immer zusammen') }
        ]
      };
    }
    const handle = this.getProductLogicHandle();
    const isGermanFamily = this.getProductHandle() === 'personalisiertes-familienportraet-aus-mehreren-fotos';
    if (isGermanFamily || ['family-portrait-add-loved-one', 'add-a-loved-one-to-a-photo'].includes(this.getProductHandle())) {
      const copy = (en, de) => isGermanFamily ? de : en;
      return {
        ...PRODUCT_FIELD_CONFIGS[handle],
        maxImages: 6,
        fields: [
          { id: 'family_background', label: copy('Choose your background', 'Hintergrund wählen'), type: 'family-select', defaultValue: 'studio', options: [
            ['photo', copy('From your first photo', 'Aus deinem ersten Foto')],
            ['studio', copy('Bright studio', 'Helles Studio')],
            ['home', copy('Cozy home', 'Gemütliches Zuhause')],
            ['garden', copy('Sunset garden', 'Garten bei Sonnenuntergang')],
            ['custom', copy('Your own idea', 'Eigene Idee')]
          ] },
          { id: 'family_background_desc', label: copy('Describe your background', 'Hintergrund beschreiben'), type: 'text', maxLength: 1000, placeholder: copy('e.g. our favorite beach at sunset', 'z. B. unser Lieblingsstrand bei Sonnenuntergang'), showWhen: { id: 'family_background', value: 'custom' } },
          { id: 'family_style', label: copy('Choose your portrait style', 'Porträtstil wählen'), type: 'family-select', defaultValue: 'photo', options: [
            ['photo', copy('Natural photo', 'Natürliches Foto')],
            ['watercolor', copy('Soft watercolor', 'Zartes Aquarell')],
            ['oil', copy('Classic oil painting', 'Klassisches Ölgemälde')],
            ...(!isGermanFamily ? [['sketch', 'Sketch']] : [])
          ] },
          ...(!isGermanFamily ? [{ id: 'family_clothing', label: 'Choose your outfits', type: 'family-select', defaultValue: 'original', options: [
            ['original', 'Keep outfits from photos'], ['casual', 'Coordinated casual outfits'], ['elegant', 'Coordinated elegant outfits']
          ] }] : []),
          { id: 'scena', label: copy('Additional wishes (optional)', 'Weitere Wünsche (optional)'), type: 'text',
            placeholder: copy('e.g. Grandma in the center, with the grandchildren beside her', 'z. B. Oma in der Mitte, die Enkelkinder neben ihr') },
          { id: 'dedykacja', label: copy('Signature or dedication (optional)', 'Text oder Widmung (optional)'), type: 'text', placeholder: copy('e.g. Together, always', 'z. B. Für immer zusammen') }
        ]
      };
    }
    return handle ? (PRODUCT_FIELD_CONFIGS[handle] || null) : null;
  },

  /** Renderuje sekcję z polami personalizacji – wstawia przed actionsArea */
  renderCustomFields() {
    const config = this.getCustomFieldConfig();
    if (!config || !config.fields || config.fields.length === 0) return;
    if (document.getElementById('customFieldsArea')) return; // już wyrenderowane

    const actionsArea = document.getElementById('actionsArea');
    if (!actionsArea) return;

    const container = document.createElement('div');
    container.id = 'customFieldsArea';
    container.style.cssText = [
      'padding: 12px 16px',
      'margin: 8px 0 0 0',
      'border-top: 1px solid #e5e5e5',
      'border-bottom: 1px solid #e5e5e5',
      'background: #fafafa',
      'border-radius: 4px'
    ].join(';');

    // Placeholder bledszy — wstrzykuj styl (gwarantowane działanie)
    if (!document.getElementById('customify-placeholder-style')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'customify-placeholder-style';
      styleEl.textContent = '.customify-personalization-input::placeholder { color: #999 !important; opacity: 0.95 !important; }';
      document.head.appendChild(styleEl);
    }

    const title = document.createElement('h4');
    const personalizationTitle = this.t('customizer.personalization.title');
    const showOptionalInTitle = personalizationTitle === 'Personalization';
    title.textContent = showOptionalInTitle ? 'Personalization - optional' : personalizationTitle;
    title.style.cssText = 'margin: 0 0 10px 0; font-size: 14px; font-weight: 600; color: #222;';
    container.appendChild(title);

    config.fields.forEach(field => {
      const group = document.createElement('div');
      group.style.cssText = 'margin-bottom: 10px;';

      const label = document.createElement('label');
      const localizedField = localizeLumlyUsaField(field);
      if (showOptionalInTitle) {
        localizedField.label = localizedField.label.replace(/\s*\(optional\)/gi, '').trim();
      }
      label.htmlFor = `customField_${field.id}`;
      label.textContent = localizedField.label + (field.required ? ' *' : '');
      label.style.cssText = 'display: block; font-size: 13px; font-weight: 500; margin-bottom: 4px; color: #444;';
      group.appendChild(label);

      let input;
      if (field.type === 'family-select') {
        input = document.createElement('select');
        input.style.cssText = 'width:100%;min-height:44px;padding:8px 10px;border:1px solid #ccc;border-radius:6px;font-size:16px;background:white;color:#222;cursor:pointer;';
        field.options.forEach(([value, name]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = name;
          option.selected = value === field.defaultValue;
          input.appendChild(option);
        });
      } else if (field.type === 'select') {
        input = document.createElement('select');
        input.style.cssText = 'width: 100%; padding: 8px 10px; border: 1px solid #ccc; border-radius: 6px; font-size: 14px; background: white; cursor: pointer;';
        if (!field.required && !field.defaultValue) {
          const placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = '-- choose --';
          input.appendChild(placeholder);
        }
        field.options.forEach(opt => {
          const option = document.createElement('option');
          option.value = opt;
          const optionIndex = field.options.indexOf(opt) + 1;
          option.textContent = field.optionLocalizationKey && window.CustomifyI18n && typeof window.CustomifyI18n.t === 'function'
            ? window.CustomifyI18n.t(`${field.optionLocalizationKey}.${optionIndex}`)
            : opt;
          if (field.defaultValue && opt === field.defaultValue) option.selected = true;
          input.appendChild(option);
        });
      } else {
        input = document.createElement('input');
        input.type = 'text';
        const ph = localizedField.placeholder || field.placeholder || '';
        input.placeholder = ph;
        input.dataset.placeholder = ph;
        input.className = 'customify-personalization-input';
        if (Number.isInteger(field.maxLength)) input.maxLength = field.maxLength;
        input.style.cssText = 'width: 100%; padding: 8px 10px; border: 1px solid #ccc; border-radius: 6px; font-size: 14px; box-sizing: border-box;';
        if (field.defaultValue) input.value = field.defaultValue;
        // Placeholder znika od razu przy focus (kliknięciu), wraca przy blur gdy puste
        input.addEventListener('focus', () => { input.placeholder = ''; });
        input.addEventListener('blur', () => { if (!input.value.trim()) input.placeholder = input.dataset.placeholder || ph; });
      }
      input.id = `customField_${field.id}`;
      input.dataset.fieldId = field.id;
      if (field.required) input.dataset.required = 'true';

      group.appendChild(input);
      container.appendChild(group);
      if (field.showWhen) {
        const selector = container.querySelector(`#customField_${field.showWhen.id}`);
        const updateVisibility = () => {
          const visible = selector?.value === field.showWhen.value;
          group.hidden = !visible;
          input.disabled = !visible;
          input.required = visible;
          input.dataset.required = visible ? 'true' : 'false';
          label.textContent = localizedField.label + (visible ? ' *' : '');
        };
        selector?.addEventListener('change', updateVisibility);
        updateVisibility();
      }
    });

    actionsArea.parentNode.insertBefore(container, actionsArea);
    console.log('🎛️ [CUSTOM-FIELDS] Wyrenderowano pola personalizacji dla:', this.getProductLogicHandle());
  },

  /**
   * Validates personalization fields.
   * Prompt construction is server-only.
   * Returns null when no config exists for current product.
   */
  collectCustomFieldsPrompt() {
    const config = this.getCustomFieldConfig();
    if (!config) return null;

    const missingLabels = [];
    config.fields.forEach(field => {
      const el = document.getElementById(`customField_${field.id}`);
      const value = el ? el.value.trim() : '';
      if (!el?.disabled && (field.required || el?.dataset.required === 'true') && !value) {
        missingLabels.push(localizeLumlyUsaField(field).label);
      }
    });
    if (missingLabels.length > 0) {
      const germanFamily = this.getProductHandle() === 'personalisiertes-familienportraet-aus-mehreren-fotos';
      throw new Error(`${germanFamily ? 'Bitte fülle die Pflichtfelder aus' : 'Please complete required fields'}: ${missingLabels.join(', ')}`);
    }

    // Prompt templates are server-only. The browser only validates and sends raw fields.
    return null;
  },

  isExpandableFamilyUpload() {
    return Boolean(this.isMultiUploadProduct?.());
  },

  setupExpandableFamilyUpload(grid) {
    if (!this.isExpandableFamilyUpload()) return;
    const area = grid.closest('#multiUploadArea');
    if (!area || grid.dataset.expandedUploadSetup) return;
    grid.dataset.expandedUploadSetup = 'true';
    const initialSlots = grid.querySelectorAll('.multi-upload-slot').length;
    this._multiUploadInitialSlots = initialSlots;
    const german = String(window.CustomifyI18n?.locale || document.documentElement.lang || 'en').startsWith('de');
    const template = grid.querySelector('.multi-upload-slot');
    if (!template) return;
    for (let idx = initialSlots; idx < 6; idx++) {
      const slot = template.cloneNode(true);
      slot.id = 'multiSlot' + idx;
      slot.classList.remove('has-photo');
      slot.removeAttribute('data-upload-bound');
      slot.style.display = 'none';
      slot.querySelectorAll('[id]').forEach(node => { node.id = node.id.replace(/\d+$/, String(idx)); });
      const label = slot.querySelector('.multi-slot-label');
      label.removeAttribute('data-customify-i18n');
      label.textContent = (german ? 'Foto ' : 'Photo ') + (idx + 1);
      const photoLabel = slot.querySelector('.family-pilot-photo-label');
      if (photoLabel) photoLabel.textContent = (german ? 'Foto ' : 'Photo ') + (idx + 1);
      const captionLabel = slot.querySelector('.family-pilot-caption-label');
      if (captionLabel) captionLabel.htmlFor = 'familyPilotCaption' + idx;
      const preview = slot.querySelector('.multi-slot-preview');
      preview.style.backgroundImage = '';
      preview.style.display = 'none';
      preview.removeAttribute('role');
      preview.removeAttribute('aria-label');
      const input = slot.querySelector('.multi-slot-input');
      input.value = '';
      slot.querySelector('.multi-slot-remove').style.display = 'none';
      grid.appendChild(slot);
    }
    grid.querySelectorAll('.multi-slot-placeholder').forEach((placeholder, idx) => {
      placeholder.setAttribute('role', 'button');
      placeholder.tabIndex = 0;
      placeholder.setAttribute('aria-label', (german ? 'Foto hinzufügen ' : 'Add photo ') + (idx + 1));
    });
    const heading = area.querySelector('[data-customify-i18n="customizer.multi_upload.title"]');
    if (heading) { heading.removeAttribute('data-customify-i18n'); heading.textContent = german ? 'Fotos der Personen hochladen' : 'Upload photos of people'; }
    const counter = document.getElementById('multiUploadCount');
    counter?.parentElement?.childNodes.forEach(node => {
      if (node.nodeType === 3) node.textContent = node.textContent.replace(/\/[24]\b/, '/6');
    });
    const pilotIntro = area.querySelector('.family-pilot-intro');
    if (pilotIntro) pilotIntro.textContent = german ? 'Jedes Foto kann eine Person oder eine Gruppe zeigen. Bis zu 6 Fotos kombinieren.' : 'Each photo can show one person or a group. Combine up to 6 photos.';
    if (this.isFamilyGrandparentsPilot()) return;
    const button = document.createElement('button');
    button.id = 'familyAddPhoto';
    button.type = 'button';
    button.className = 'family-add-photo';
    button.textContent = german ? '+ Weiteres Foto hinzufügen' : '+ Add another photo';
    button.style.cssText = 'display:block!important;width:min(380px,100%)!important;min-height:44px!important;margin:12px auto 0!important;padding:10px 14px!important;border:1px solid #ddd!important;border-radius:6px!important;background:#fff!important;color:#444!important;font-size:14px!important;font-weight:500!important;cursor:pointer!important;';
    counter?.parentElement?.insertAdjacentElement('afterend', button);
    if (this.isTogetherCoupleProduct()) {
      const help = document.createElement('p');
      help.textContent = german ? 'Weitere Fotos können zusätzliche Personen zum Porträt hinzufügen. Ein klares Foto pro Person.' : 'Add more photos to include additional people in your portrait. One clear photo per person.';
      help.style.cssText = 'text-align:center;font-size:12px;color:#777;margin:8px 0;';
      button.insertAdjacentElement('afterend', help);
    }
    button.addEventListener('click', () => {
      if (this._familyCropLocked || this._familyHasPendingCrops()) return;
      const idx = Array.from({ length: 6 - initialSlots }, (_, offset) => initialSlots + offset).find(index => !this.multiUploadFiles[index]);
      if (idx === undefined) return;
      const input = grid.querySelectorAll('.multi-upload-slot')[idx]?.querySelector('.multi-slot-input');
      if (!input) return;
      this._familyCropReturnFocus = this._familyCropReturnFocus || Array(6).fill(null);
      this._familyCropReturnFocus[idx] = button;
      input.click();
    });
  },

  // 📸 Produkt multi-upload (dodaj osobę do zdjęcia)
  isTogetherCoupleProduct() {
    return ['together-couple-portrait-from-two-photos', 'custom-couple-painting-from-two-photos', 'personalisiertes-paarportraet-aus-zwei-fotos'].includes(this.getProductHandle());
  },

  isMultiUploadProduct() {
    const h = this.getProductLogicHandle();
    return h === 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk';
  },

  setupMultiUpload() {
    if (!this.isMultiUploadProduct()) return;
    const grid = document.querySelector('.multi-upload-grid');
    if (!grid) return;
    while (this.multiUploadFiles.length < 6) this.multiUploadFiles.push(null);
    while (this.multiUploadPreviews.length < 6) this.multiUploadPreviews.push(null);
    this.setupExpandableFamilyUpload(grid);
    grid.closest('#multiUploadArea')?.classList.toggle('family-visible-upload', this.getProductHandle() === 'grandparents-and-grandchildren-portrait-from-photos');
    grid.closest('#multiUploadArea')?.classList.toggle('family-square-upload', ['family-portrait-add-loved-one', 'add-a-loved-one-to-a-photo', 'personalisiertes-familienportraet-aus-mehreren-fotos'].includes(this.getProductHandle()));
    grid.querySelectorAll('.multi-upload-slot').forEach((slot, idx) => {
      if (slot.dataset?.uploadBound) return;
      if (slot.dataset) slot.dataset.uploadBound = 'true';
      const input = slot.querySelector('.multi-slot-input');
      const placeholder = slot.querySelector('.multi-slot-placeholder');
      const preview = slot.querySelector('.multi-slot-preview');
      const removeBtn = slot.querySelector('.multi-slot-remove');
      const editPilotCrop = (returnFocus) => {
        if (!this.usesFamilyPhotoCrop()) return;
        const acceptedFile = this.multiUploadFiles[idx];
        const acceptedCropper = this.familyCropperBySlot?.[idx];
        if (!acceptedFile || !acceptedCropper || this._familyCropLocked || this._familyHasPendingCrops()) return;
        this.handleGrandparentsPilotFileSelect(acceptedFile, idx, {
          initialRect: acceptedCropper.getRect(),
          preserveCaption: true,
          allowReplace: true,
          returnFocus
        });
      };
      if (placeholder) {
        placeholder.addEventListener('click', () => !this._familyCropLocked && input && input.click());
        placeholder.addEventListener('keydown', (event) => {
          if ((event.key === 'Enter' || event.key === ' ') && !this._familyCropLocked) {
            event.preventDefault();
            input && input.click();
          }
        });
      }
      if (preview && this.usesFamilyPhotoCrop()) {
        preview.addEventListener('click', () => editPilotCrop(preview));
        preview.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            editPilotCrop(preview);
          }
        });
      }
      if (input) {
        input.addEventListener('change', (e) => {
          if (e.target.files && e.target.files[0]) {
            if (this.usesFamilyPhotoCrop()) {
              const returnFocus = this._familyCropReturnFocus?.[idx] || placeholder;
              this.handleGrandparentsPilotFileSelect(e.target.files[0], idx, { returnFocus });
              if (this._familyCropReturnFocus) this._familyCropReturnFocus[idx] = null;
            }
            else this.handleMultiFileSelect(e.target.files[0], idx);
          }
        });
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.removeMultiFile(idx);
        });
      }
      if (this.isFamilyGrandparentsPilot()) {
        const caption = slot.querySelector('.family-pilot-caption');
        if (caption) caption.addEventListener('input', () => {
          this.multiUploadCaptions = this.multiUploadCaptions || Array(this.multiUploadFiles?.length || 4).fill('');
          this.multiUploadCaptions[idx] = caption.value.slice(0, 120);
        });
      }
    });
    if (this.isFamilyGrandparentsPilot()) {
      const addPhoto = document.getElementById('familyPilotAddPhoto');
      if (addPhoto) addPhoto.addEventListener('click', () => {
        if (this._familyCropLocked || this._familyHasPendingCrops()) return;
        const nextSlot = window.FamilyInlineCrop?.firstEmptySlot(this.multiUploadFiles, this.multiUploadFiles.length) ?? this.multiUploadFiles.findIndex(file => !file);
        if (nextSlot < 0) return;
        const input = document.querySelectorAll('.multi-upload-slot')[nextSlot]?.querySelector('.multi-slot-input');
        if (!input) return;
        this._familyCropReturnFocus = this._familyCropReturnFocus || Array(4).fill(null);
        this._familyCropReturnFocus[nextSlot] = addPhoto;
        input.click();
      });
      this.updateMultiUploadCounter();
    }
    this.updateMultiUploadCounter();
    console.log('📸 [MULTI-UPLOAD] Setup complete');
  },

  async handleMultiFileSelect(file, slotIndex) {
    if (!file || !file.type.startsWith('image/')) {
      this.showError('Choose an image file (JPG, PNG)', 'upload');
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      this.showError('File is too large (max 10MB)', 'upload');
      return;
    }
    this._multiPhotoSelectionIds ||= [0, 0, 0, 0];
    const selectionId = ++this._multiPhotoSelectionIds[slotIndex];
    const slot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
    this.hideError();
    try {
      const snapshot = (this.preparePhotoFile ? await this.preparePhotoFile(file) : file);
      const dataUrl = (this.readPhotoDataUrl ? await this.readPhotoDataUrl(snapshot) : await new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload = () => resolve(reader.result); reader.onerror = () => reject(new Error('Could not read photo')); reader.readAsDataURL(snapshot); }));
      if (selectionId !== this._multiPhotoSelectionIds[slotIndex]) return;
      this.multiUploadFiles[slotIndex] = snapshot;
      this.multiUploadPreviews[slotIndex] = dataUrl;
      if (slot) {
        const preview = slot.querySelector('.multi-slot-preview');
        const placeholder = slot.querySelector('.multi-slot-placeholder');
        const removeBtn = slot.querySelector('.multi-slot-remove');
        const input = slot.querySelector('.multi-slot-input');
        if (preview) { preview.style.backgroundImage = 'url(' + dataUrl + ')'; preview.style.display = 'block'; }
        if (placeholder) placeholder.style.display = 'none';
        if (removeBtn) removeBtn.style.display = 'flex';
        if (input) input.value = '';
      }
      this.uploadedFile = this.getMultiUploadFiles()[0] || null;
      this.updateMultiUploadCounter();
      this.trackStatsEvent('image_upload');
    } catch (error) {
      if (selectionId !== this._multiPhotoSelectionIds[slotIndex]) return;
      this.reportPhotoReadError(error, file, 'multi-selection');
      this.showError(error.message, 'upload');
    }
  },

  async handleGrandparentsPilotFileSelect(file, slotIndex, options = {}) {
    if (this._familyCropLocked) return;
    if (!Number.isInteger(slotIndex) || slotIndex < 0 || slotIndex >= (this.multiUploadFiles?.length || 4)) return;
    if (!file || !file.type.startsWith('image/')) {
      this.showError(this.t('customizer.error.image_file'), 'upload');
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      this.showError(this.t('customizer.error.file_too_large'), 'upload');
      return;
    }
    this._familyUploadVersions = this._familyUploadVersions || Array(this.multiUploadFiles?.length || 4).fill(0);
    this.familyCropperBySlot = this.familyCropperBySlot || Array(this.multiUploadFiles?.length || 4).fill(null);
    this.multiUploadCaptions = this.multiUploadCaptions || Array(this.multiUploadFiles?.length || 4).fill('');
    const version = ++this._familyUploadVersions[slotIndex];
    this._familyPendingCropTokens = this._familyPendingCropTokens || new Set();
    const token = `${slotIndex}:${version}`;
    this._familyPendingCropTokens.add(token);
    this.updateMultiUploadCounter();
    const slot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
    if (!slot) { this._familyPendingCropTokens.delete(token); return; }
    const preview = slot.querySelector('.multi-slot-preview');
    const placeholder = slot.querySelector('.multi-slot-placeholder');
    const removeBtn = slot.querySelector('.multi-slot-remove');
    const caption = slot.querySelector('.family-pilot-caption');
    const input = slot.querySelector('.multi-slot-input');
    let candidateCropper = null;
    try {
      if (!window.FamilyInlineCrop || typeof window.FamilyInlineCrop.openDialog !== 'function') throw new Error('The crop dialog is still loading. Please try again.');
      const germanCrop = this.getProductHandle() === 'personalisiertes-familienportraet-aus-mehreren-fotos';
      candidateCropper = await window.FamilyInlineCrop.openDialog(file, {
        alt: `Photo ${slotIndex + 1} crop`,
        aspectRatio: ['family-portrait-add-loved-one', 'add-a-loved-one-to-a-photo', 'personalisiertes-familienportraet-aus-mehreren-fotos'].includes(this.getProductHandle()) ? 1 : undefined,
        initialRect: options.initialRect,
        returnFocus: options.returnFocus || placeholder,
        allowReplace: Boolean(options.allowReplace),
        title: germanCrop ? (options.preserveCaption ? `Foto ${slotIndex + 1} bearbeiten` : `Foto ${slotIndex + 1} hinzufügen`) : (options.preserveCaption ? `Edit photo ${slotIndex + 1}` : `Add photo ${slotIndex + 1}`),
        labels: germanCrop ? { help: 'Wähle die Personen aus, die enthalten sein sollen', loading: 'Foto wird vorbereitet…', change: 'Foto ändern', cancel: 'Abbrechen', done: 'Fertig' } : undefined,
        replacementTitle: germanCrop ? 'Foto ändern' : undefined
      });
      if (!candidateCropper) return;
      const acceptedFile = candidateCropper.getFile?.() || file;
      const croppedPreview = await candidateCropper.toFile();
      if (version !== this._familyUploadVersions[slotIndex]) { candidateCropper.destroy(); candidateCropper = null; return; }

      const previewUrl = URL.createObjectURL(croppedPreview);
      const previousCropper = this.familyCropperBySlot[slotIndex];
      const previousPreviewUrl = this._familyPreviewUrls?.[slotIndex];
      if (previousCropper && previousCropper !== candidateCropper) previousCropper.destroy();
      if (previousPreviewUrl) URL.revokeObjectURL(previousPreviewUrl);
      this._familyPreviewUrls = this._familyPreviewUrls || Array(this.multiUploadFiles?.length || 4).fill(null);
      this._familyPreviewUrls[slotIndex] = previewUrl;
      this.familyCropperBySlot[slotIndex] = candidateCropper;
      this.multiUploadFiles[slotIndex] = acceptedFile;
      this.multiUploadPreviews[slotIndex] = previewUrl;
      const captionPreserved = options.preserveCaption && acceptedFile === file;
      if (!captionPreserved) this.multiUploadCaptions[slotIndex] = '';
      if (preview) {
        preview.style.backgroundImage = `url("${previewUrl}")`;
        preview.style.display = 'block';
        preview.setAttribute('role', 'button');
        preview.tabIndex = 0;
        preview.setAttribute('aria-label', `Edit crop for photo ${slotIndex + 1}`);
      }
      if (placeholder) placeholder.style.display = 'none';
      if (removeBtn) removeBtn.style.display = 'flex';
      if (caption) {
        caption.value = this.multiUploadCaptions[slotIndex] || '';
        caption.disabled = false;
      }
      slot.classList.add('has-photo');
      candidateCropper = null;
      if (!captionPreserved) {
        this.trackStatsEvent('image_upload');

      }
      this.uploadedFile = this.multiUploadFiles.find(Boolean) || null;
      this.updateMultiUploadCounter();
    } catch (error) {
      candidateCropper?.destroy();
      if (version === this._familyUploadVersions[slotIndex]) this.showError(error.message || 'This photo could not be opened. Please choose another image.', 'upload');
    } finally {
      this._familyPendingCropTokens.delete(token);
      if (input) input.value = '';
      this.updateMultiUploadCounter();
    }
  },

  _familyHasPendingCrops() {
    return Boolean(this._familyPendingCropTokens?.size);
  },

  removeMultiFile(slotIndex) {
    if (this.usesFamilyPhotoCrop() && this._familyCropLocked) return;
    if (this.usesFamilyPhotoCrop()) {
      this._familyUploadVersions = this._familyUploadVersions || Array(this.multiUploadFiles?.length || 4).fill(0);
      this._familyUploadVersions[slotIndex] += 1;
      this.familyCropperBySlot?.[slotIndex]?.destroy();
      if (this.familyCropperBySlot) this.familyCropperBySlot[slotIndex] = null;
      const previewUrl = this._familyPreviewUrls?.[slotIndex];
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      if (this._familyPreviewUrls) this._familyPreviewUrls[slotIndex] = null;
      if (this.multiUploadCaptions) this.multiUploadCaptions[slotIndex] = '';
      const pilotSlot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
      const pilotCaption = pilotSlot?.querySelector('.family-pilot-caption');
      const pilotPreview = pilotSlot?.querySelector('.multi-slot-preview');
      if (pilotPreview) { pilotPreview.style.backgroundImage = ''; pilotPreview.style.display = 'none'; }
      pilotPreview?.removeAttribute('role');
      pilotPreview?.removeAttribute('aria-label');
      if (pilotPreview) pilotPreview.tabIndex = -1;
      if (pilotCaption) { pilotCaption.value = ''; pilotCaption.disabled = true; }
      pilotSlot?.classList.remove('has-photo');
    }
    this.multiUploadFiles[slotIndex] = null;
    this.multiUploadPreviews[slotIndex] = null;
    const slot = document.querySelectorAll('.multi-upload-slot')[slotIndex];
    if (slot) {
      const preview = slot.querySelector('.multi-slot-preview');
      const placeholder = slot.querySelector('.multi-slot-placeholder');
      const removeBtn = slot.querySelector('.multi-slot-remove');
      const input = slot.querySelector('.multi-slot-input');
      if (preview) { preview.style.backgroundImage = ''; preview.style.display = 'none'; }
      if (placeholder) placeholder.style.display = 'flex';
      if (removeBtn) removeBtn.style.display = 'none';
      if (input) input.value = '';
    }
    this.updateMultiUploadCounter();
    const remaining = this.getMultiUploadFiles();
    if (remaining.length === 0) this.uploadedFile = null;
    else this.uploadedFile = remaining[0];
  },

  updateMultiUploadCounter() {
    if (this.isExpandableFamilyUpload?.()) {
      const slots = document.querySelectorAll('.multi-upload-slot');
      const initialSlots = this._multiUploadInitialSlots || (this.isTogetherCoupleProduct() ? 2 : 4);
      for (let idx = initialSlots; idx < 6; idx++) {
        if (slots[idx]) slots[idx].style.display = this.multiUploadFiles[idx] ? '' : 'none';
      }
      const addPhoto = document.getElementById('familyAddPhoto');
      if (addPhoto) {
        const full = this.multiUploadFiles.slice(initialSlots).every(Boolean);
        addPhoto.disabled = full || this._familyCropLocked || this._familyHasPendingCrops();
        addPhoto.style.opacity = addPhoto.disabled ? '0.5' : '1';
        addPhoto.setAttribute('aria-disabled', String(addPhoto.disabled));
      }
    }
    const counter = document.getElementById('multiUploadCount');
    if (counter) {
      const count = this.multiUploadFiles.filter(f => f !== null).length;
      counter.textContent = count;
    }
    if (this.isFamilyGrandparentsPilot()) {
      const count = window.FamilyInlineCrop?.acceptedPhotoCount?.(this.multiUploadFiles, this.multiUploadFiles.length) ?? this.multiUploadFiles.filter(Boolean).length;
      const title = document.querySelector('.family-pilot-title');
      const addPhoto = document.getElementById('familyPilotAddPhoto');
      if (title) title.textContent = count ? `Your photos · ${count}/${this.multiUploadFiles.length}` : 'Add your photos';
      if (addPhoto) {
        addPhoto.textContent = count ? '+ Add another photo' : 'Add photo';
        addPhoto.hidden = count >= this.multiUploadFiles.length;
        addPhoto.disabled = this._familyCropLocked || this._familyHasPendingCrops();
      }
    }
  },

  getMultiUploadFiles() {
    if (this.usesFamilyPhotoCrop() && this._familyPilotSnapshot) return this._familyPilotSnapshot.files.slice();
    return this.multiUploadFiles.filter(f => f !== null);
  },

  setFamilyPilotBusy(isBusy) {
    this._familyCropLocked = Boolean(isBusy);
    const area = document.getElementById('multiUploadArea');
    if (area) area.classList.toggle('is-busy', this._familyCropLocked);
    document.querySelectorAll('#multiUploadArea .multi-slot-input, #multiUploadArea .family-crop-handle').forEach(control => { control.disabled = this._familyCropLocked; });
    document.querySelectorAll('#multiUploadArea .family-pilot-caption').forEach(control => {
      control.disabled = this._familyCropLocked || !control.closest('.family-pilot-slot')?.classList.contains('has-photo');
    });
    document.querySelectorAll('#multiUploadArea .multi-slot-remove').forEach(control => {
      control.disabled = this._familyCropLocked;
    });
    const addPhoto = document.getElementById('familyPilotAddPhoto');
    if (addPhoto) addPhoto.disabled = this._familyCropLocked || this._familyHasPendingCrops();
    this.updateMultiUploadCounter();
  },

  async transformImage(retryCount = 0) {
    if (this._isOffline()) {
      this.showError('No internet connection. Check your network and try again.', 'transform');
      return;
    }
    this._sentryCrumb('transform', 'Start transformImage', { style: this.selectedStyle, retry: retryCount });
    console.log(`🔍🔍🔍 [TRANSFORM] START transformImage:`, {
      selectedStyle: this.selectedStyle,
      selectedStyleType: typeof this.selectedStyle,
      productType: this.selectedStyle ? this.getProductTypeFromStyle(this.selectedStyle) : 'BRAK STYLU',
      uploadedFile: !!this.uploadedFile,
      uploadedFileName: this.uploadedFile?.name
    });
    
    if (this.usesFamilyPhotoCrop() && this._familyHasPendingCrops()) {
      this.showError('Finish or cancel the open photo crop before creating your portrait.', 'transform'); return;
    }
    if (this.isMultiUploadProduct()) {
      const multiFiles = this.getMultiUploadFiles();
      if (this.isTogetherCoupleProduct() && (multiFiles.length < 2 || multiFiles.length > 6)) {
        this.showError('Upload 2 to 6 photos to create your portrait.', 'transform'); return;
      }
      this.uploadedFile = multiFiles[0] || null;
      if (multiFiles.length === 0) {
        this.showError('Upload at least one photo', 'transform');
        return;
      }
      if (!this.uploadedFile) this.uploadedFile = multiFiles[0];
    } else if (!this.uploadedFile || !this.selectedStyle) {
      console.error(`❌ [TRANSFORM] Brak wymaganych danych:`, {
        uploadedFile: !!this.uploadedFile,
        selectedStyle: this.selectedStyle
      });
      this.showError('Upload a photo and choose a style', 'transform');
      return;
    }

    // Dla spotify: sprawdź czy zdjęcie zostało wykadrowane
    // - spotifyCropConfirmed = true (świeżo wykadrowane)
    // - lub uploadedFile.name zaczyna się od 'spotify-crop-' (już wykadrowane, po "spróbuj ponownie")
    const isSpotifyCropped = this.spotifyCropConfirmed || 
      (this.uploadedFile && this.uploadedFile.name && this.uploadedFile.name.startsWith('spotify-crop-'));
    
    if (this.isSpotifyProduct() && !isSpotifyCropped) {
      this.showError('Crop the photo first', 'transform');
      return;
    }

    // 📱 Dla telefonu: sprawdź czy zdjęcie zostało wykadrowane
    const isPhoneCropped = this.phoneCropConfirmed || 
      (this.uploadedFile && this.uploadedFile.name && this.uploadedFile.name.startsWith('phone-crop-'));
    
    if (this.isPhoneCaseProduct() && !isPhoneCropped) {
      this.showError('Crop the photo first', 'transform');
      return;
    }
    
    // 📱 Dla etui (zdjęcie): sprawdź czy zdjęcie zostało wykadrowane
    const isPhonePhotoCropped = this.phonePhotoCropConfirmed || 
      (this.uploadedFile && this.uploadedFile.name && this.uploadedFile.name.startsWith('phone-photo-crop-'));
    
    if (this.isPhonePhotoCaseProduct() && !isPhonePhotoCropped) {
      this.showError('Crop the photo first', 'transform');
      return;
    }

      // 🎛️ CUSTOM FIELDS: Validate required personalization fields. Prompt is built on backend.
      try {
        this.collectCustomFieldsPrompt();
      } catch (fieldError) {
        this._reportToSentry(fieldError, 'collectCustomFieldsPrompt');
        this.showError(fieldError.message, 'transform');
        this.hideLoading();
        return;
      }

      let spotifyPayload = null;
      if (this.isSpotifyProduct()) {
        const spotifyTitle = (this.spotifyTitleInput?.value || '').trim().slice(0, 60);
        const spotifyArtist = (this.spotifyArtistInput?.value || '').trim().slice(0, 60);
        spotifyPayload = { title: spotifyTitle, artist: spotifyArtist };
      }

    // 🎵 SPOTIFY: Styl "bez-zmian" - pomijamy AI, pokazujemy widok jak po generacji
    if (this.selectedStyle === 'bez-zmian') {
      console.log('🎵 [SPOTIFY] Styl "bez-zmian" - pomijamy transformację AI');
      this.showLoading();
      
      // Użyj wykadrowanego zdjęcia jako transformedImage (dla addToCart)
      const reader = new FileReader();
      reader.onload = (e) => {
        this.transformedImage = e.target.result;
        this.watermarkedImageUrl = null; // Będzie generowany przy dodaniu do koszyka
        
        // Ukryj sekcje jak po normalnej generacji
        if (this.uploadArea) this.uploadArea.style.display = 'none';
        if (this.stylesArea) this.stylesArea.style.display = 'none';
        if (this.actionsArea) this.actionsArea.style.display = 'none';
        
        // Pokaż przyciski koszyka
        if (this.cartActionsArea) this.cartActionsArea.style.display = 'flex';
        
        // Pokaż rozmiary i typ wydruku
        if (this.sizeArea) this.sizeArea.style.display = 'block';
        if (this.productTypeArea) this.productTypeArea.style.display = 'block';
        
        // Preview z maską pozostaje widoczny (nie zmieniamy na resultArea)
        // Komunikat sukcesu
        this.showSuccess('Project ready! Choose print options and add to cart.');
        this.hideLoading();
        
        console.log('✅ [SPOTIFY] Styl "bez-zmian" - widok jak po generacji, gotowe do koszyka');
      };
      reader.readAsDataURL(this.uploadedFile);
      return;
    }

    // ✅ DEBUG: Sprawdź selectedStyle przed checkUsageLimit
    console.log(`🔍 [TRANSFORM] Przed checkUsageLimit:`, {
      selectedStyle: this.selectedStyle,
      productType: this.getProductTypeFromStyle(this.selectedStyle),
      uploadedFile: !!this.uploadedFile
    });

    // ✅ USAGE LIMITS: Sprawdź limit PRZED transformacją (ZAWSZE, nawet przy retry)
      const canTransform = await this.checkUsageLimit();
      if (!canTransform) {
        console.log('❌ [USAGE] Limit przekroczony - przerwano transformację');
        return;
    }

    // ✅ Google Analytics Event Tracking - "Zobacz Preview" kliknięty
    if (retryCount === 0 && typeof gtag !== 'undefined') {
      gtag('event', 'zobacz_podglad_click', {
        'event_category': 'Customify',
        'event_label': this.selectedStyle,
        'style_name': this.selectedStyle,
        'product_url': window.location.pathname
      });
      console.log('📊 [GA4] Event sent: zobacz_podglad_click', {
        style: this.selectedStyle,
        url: window.location.pathname
      });
    }

    this.showLoading();
    this.hideError();
    
    if (retryCount > 0) {
      console.log(`🔄 [MOBILE] Retry attempt ${retryCount}/3`);
    }

    try {
      if (this.usesFamilyPhotoCrop()) {
        if (!window.FamilyInlineCrop || typeof window.FamilyInlineCrop.buildEntries !== 'function') throw new Error('The inline crop tool is still loading. Please wait a moment and try again.');
        const entries = window.FamilyInlineCrop.buildEntries(this.multiUploadFiles, this.multiUploadCaptions, this.multiUploadFiles.length).map(entry => ({
          ...entry,
          cropper: this.familyCropperBySlot?.[entry.slot],
          version: this._familyUploadVersions?.[entry.slot] || 0
        }));
        if (!entries.length || entries.some(entry => !entry.cropper || typeof entry.cropper.toFile !== 'function')) {
          throw new Error('Please wait for each photo crop to finish loading, then try again.');
        }
        this.setFamilyPilotBusy(true);
        const croppedFiles = await Promise.all(entries.map(entry => entry.cropper.toFile()));
        if (entries.some(entry => (this._familyUploadVersions?.[entry.slot] || 0) !== entry.version || this.multiUploadFiles[entry.slot] !== entry.file || this.familyCropperBySlot?.[entry.slot] !== entry.cropper)) {
          throw new Error('A photo changed while the crop was being prepared. Please review the photos and try again.');
        }
        this._familyPilotSnapshot = { entries, files: croppedFiles };
        this.uploadedFile = croppedFiles[0];
      }
      const base64 = (this.isSpotifyProduct() && this.spotifyCropConfirmed && this.spotifyCropDataUrl)
        ? this.spotifyCropDataUrl
        : (this.isPhoneCaseProduct() && this.phoneCropConfirmed && this.phoneCropDataUrl)
        ? this.phoneCropDataUrl
        : (this.isPhonePhotoCaseProduct() && this.phonePhotoCropConfirmed && this.phonePhotoCropDataUrl)
        ? this.phonePhotoCropDataUrl
        : await this.fileToBase64(this.uploadedFile);
      
      // Create AbortController for timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 300000); // 5 minutes
      
      
      // ✅ Użyj productType z stylu (zgodne z backend - config.productType)
      const productType = this.getProductTypeFromStyle(this.selectedStyle);
      
      // ✅ USAGE LIMITS: Pobierz dane użytkownika do przekazania do API
      const customerInfo = this.getCustomerInfo();
      
      // ✅ Pobierz email z localStorage (jeśli był w formularzu) lub z customerInfo
      const email = customerInfo?.email || safeLocalStorageGet('customify_email_provided') || null;
      
      const requestBody = {
        imageData: base64,
        // ❌ USUNIĘTO: prompt - backend używa config.prompt z konfiguracji stylu (jak dla króla, kotów, etc.)
        style: this.selectedStyle, // ✅ STYL - API użyje tego do identyfikacji stylu i pobrania prompta z config
        productType: productType, // Przekaż typ produktu do API
        productHandle: this.getProductHandle(),
        customerId: customerInfo?.customerId || null,
        // Fallback dla przeglądarek blokujących third-party cookie domeny Vercel.
        deviceToken: safeLocalStorageGet('customify_device_token', null),
        // ✅ EMAIL: ZAWSZE wysyłaj email jeśli dostępny (dla zalogowanych i niezalogowanych)
        // Backend użyje tego do ustawienia metafield generation_ready dla emaili Shopify Flow
        email: customerInfo?.email || email || null
        // ❌ USUNIĘTO: watermarkedImage - watermark generujemy PO transformacji AI, nie przed!
      };
      
      if (spotifyPayload) {
        requestBody.spotifyTitle = spotifyPayload.title;
        requestBody.spotifyArtist = spotifyPayload.artist;
      }

      // 📊 PERSONALIZATION: send raw field values only. Backend builds the prompt from productHandle + fields.
      const cfgForLog = this.getCustomFieldConfig();
      if (cfgForLog && cfgForLog.fields) {
        const rawFields = {};
        cfgForLog.fields.forEach(field => {
          const el = document.getElementById(`customField_${field.id}`);
          if (el && !el.disabled && el.value && el.value.trim()) {
            rawFields[field.id] = el.value.trim();
          }
        });
        if (this.isFamilyGrandparentsPilot()) rawFields.photoCaptions = window.FamilyInlineCrop.buildRequestMetadata(this._familyPilotSnapshot.entries).photoCaptions;
        requestBody.personalizationFields = rawFields;
      }

      // 📸 MULTI-UPLOAD: Upload dodatkowych zdjęć do Vercel Blob i dodaj URL-e
      if (this.isMultiUploadProduct()) {
        const multiFiles = this.getMultiUploadFiles();
        const additionalImageUrls = [];
        for (let i = 1; i < multiFiles.length; i++) {
          const file = multiFiles[i];
          const fileBase64 = await this.fileToBase64(file);
          console.log(`📸 [MULTI-UPLOAD] Uploading image ${i+1}/${multiFiles.length} to Vercel Blob...`);
          try {
            const uploadResp = await fetch('https://lumly-canada.vercel.app/api/upload-temp-image', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ imageData: fileBase64, filename: `multi-upload-${Date.now()}-${i}.jpg` })
            });
            if (uploadResp.ok) {
              const uploadResult = await uploadResp.json();
              if (uploadResult.url) {
                additionalImageUrls.push(uploadResult.url);
                console.log(`📸 [MULTI-UPLOAD] Image ${i+1} uploaded:`, uploadResult.url.substring(0, 80));
              }
            }
          } catch (uploadErr) {
            console.warn(`⚠️ [MULTI-UPLOAD] Failed to upload image ${i+1}:`, uploadErr);
          }
        }
        if (additionalImageUrls.length !== multiFiles.length - 1) throw new Error('Could not upload every photo. Please try again so everyone stays in the portrait.');
        if (additionalImageUrls.length > 0) {
          requestBody.additionalImages = additionalImageUrls;
          console.log(`📸 [MULTI-UPLOAD] Total additional images: ${additionalImageUrls.length}`);
        }
      }
      
      // Logi diagnostyczne - bez promptu, personalizacji, emaila (prywatność)
      
      
      
      const response = await fetch('https://lumly-canada.vercel.app/api/transform', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(requestBody),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('📱 [MOBILE] Response error:', errorText);

        let errorJson = null;
        try {
          errorJson = JSON.parse(errorText);
        } catch (parseError) {
          console.warn('⚠️ [MOBILE] Failed to parse error JSON:', parseError);
        }

        if (response.status === 403 && errorJson?.error === 'Usage limit exceeded') {
          console.warn('⚠️ [USAGE] Limit exceeded response from API:', errorJson);

          if (!customerInfo) {
            const usedCount = typeof errorJson.usedCount === 'number'
              ? errorJson.usedCount
              : (typeof errorJson.count === 'number' ? errorJson.count : 1);
            const totalLimit = typeof errorJson.totalLimit === 'number'
              ? errorJson.totalLimit
              : (typeof errorJson.limit === 'number' ? errorJson.limit : 1);

            try {
              const FREE_LIMIT = 1;
              const enforcedCount = Math.max(usedCount, FREE_LIMIT);
              safeLocalStorageSet('customify_usage_count', enforcedCount.toString());
              console.log('💾 [USAGE] Synced local usage count to', enforcedCount);
            } catch (storageError) {
              console.warn('⚠️ [USAGE] Failed to sync local usage count:', storageError);
            }

            this.showLoginModal(usedCount, totalLimit);
          } else {
            this.trackLimitFunnelShowLimit(customerInfo, {
              wallTier: errorJson.wallTier || 'unknown',
              source: 'transform_403'
            });
            this.showLimitWallModal(customerInfo, errorJson);
          }

          return;
        }

        if (response.status === 403 && errorJson?.error === 'Image already used') {
          console.warn('⚠️ [IMAGE-HASH] Image already used response from API:', errorJson);
          const baseMessage = errorJson.message || 'This photo already has a result. See it below, or try another photo or product';
          // Utwórz komunikat z linkiem do innych produktów
          const messageWithLink = `${baseMessage} <a href="/collections/see_also" style="color: #0066cc; text-decoration: underline;">See other products</a>`;
          this.showErrorWithHTML(messageWithLink, 'transform');
          return;
        }

        if (errorJson?.error === 'CROPPED_FACE') {
          const msg = errorJson.message || 'The photo must show the full face from the front. Use a photo where the face is fully visible and not cropped.';
          this.showError(msg, 'transform');
          return;
        }

        if (response.status === 400) {
          const backendError = (errorJson?.error || '').toString();
          const normalizedError = backendError.toLowerCase();
          const isModerationError =
            normalizedError.includes('odrzucone przez system bezpieczeństwa') ||
            normalizedError.includes('filtr bezpieczeństwa') ||
            normalizedError.includes('nsfw') ||
            normalizedError.includes('content detected') ||
            normalizedError.includes('moderation');

          if (isModerationError) {
            this.showError(
              'The photo was rejected by the safety filter. Use a photo with a clear face and neutral clothing.',
              'transform'
            );
            return;
          }
        }

        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const result = await response.json();
      if (typeof result.deviceToken === 'string' && /^[a-f0-9]{32}$/i.test(result.deviceToken)) {
        safeLocalStorageSet('customify_device_token', result.deviceToken.toLowerCase());
      }
      
      if (result.success) {
        if (!result.watermarkedImageUrl) {
          console.error('❌ [TRANSFORM] Backend returned a result without a watermark; refusing to expose the print file');
          this.hideLoading();
          this.showError('The preview could not be secured. Please try again.', 'transform');
          return;
        }
        this.transformedImage = result.transformedImage;
        if (customerInfo?.customerId) {
          this.trackLimitFunnelGenerationSuccess(customerInfo);
        }
        // ✅ STATS: Generacje AI zlicza backend (transform.js) – jedna źródło prawdy, bez podwójnego liczenia
        // ✅ ZAPISZ watermarkedImageUrl z backendu (jeśli dostępny)
        this.watermarkedImageUrl = result.watermarkedImageUrl || null;
        // ✅ NOWE: ZAPISZ watermarkedImageBase64 z backendu (dla /api/products - BEZ PONOWNEGO DOWNLOADU)
        this.watermarkedImageBase64 = result.watermarkedImageBase64 || null;
        this.artworkId = result.artworkId || result.saveGenerationDebug?.artworkId || null;
        this.generationId = result.generationId || result.saveGenerationDebug?.generationId || null;
        this.hideError(); // Ukryj komunikat błędu po udanej transformacji
        
        // ✅ AWAIT: Czekaj aż wynik zostanie pokazany
        // showResult() użyje watermarkedImageUrl jeśli dostępny, w przeciwnym razie transformedImage
        await this.showResult(result.transformedImage);
        if (!this.isPhonePhotoCaseProduct || !this.isPhonePhotoCaseProduct()) {
          if (customerInfo) {
            // Zalogowany: pokaż komunikat bez ujawniania licznika pozostałych prób.
            this.showSuccess('Image saved. It is available in <a href="https://snaptoonify.com/pages/my-generations" target="_blank" rel="noopener">My images</a>.<br><span style="font-size:0.88em;color:#555;">If something is wrong in the image, such as text or spelling, our designer can correct it manually. Add a note when placing the order.</span>', { html: true });
          } else {
            this.showSuccess('Image saved. You can view it later in My images below.<br><span style="font-size:0.88em;color:#555;">If something is wrong in the image, such as text or spelling, our designer can correct it manually. Add a note when placing the order.</span>', { html: true });
          }
        }
        
        // ✅ UKRYJ PASEK POSTĘPU - obraz jest już widoczny, reszta działa w tle
        this.hideLoading();

        // 🆕 Tekst na obrazie – pokaż panel dopiero po generacji (tylko produkt pilota)
        if (this.textOverlayEnabled && this.textOverlayPanel) {
          this.watermarkedImageUrl = result.watermarkedImageUrl;
          this.textOverlayBaseImage = result.transformedImage || null;
          this.textOverlayOriginalWatermarked = result.watermarkedImageUrl || null;
          this.textOverlayState = { ...this.textOverlayState, text: '', applied: false };
          if (this.textOverlayInput) {
            this.textOverlayInput.value = '';
            this.updateTextOverlayCounter();
          }
          this.textOverlayPanel.style.display = 'none';
          this.textOverlayToggleBtn?.setAttribute('data-overlay-open', 'false');
          this.updateTextOverlayHint('');
        }
        
        // ✅ BACKEND WATERMARK: Backend już generuje watermark i zwraca watermarkedImageUrl w response
        // ✅ Backend zapisuje watermarkedImageUrl w save-generation-v2 automatycznie
        // ✅ NIE WYSYŁAMY już frontend watermarku do /api/update-generation-watermark (stary system)
        // watermark jest wymagany i został sprawdzony przed pokazaniem wyniku
        
        // ✅ STARY KOD USUNIĘTY: Frontend watermark generation i /api/update-generation-watermark
        // ✅ Backend już generuje watermark i zwraca watermarkedImageUrl w response
        // ✅ showResult() w theme.liquid używa this.watermarkedImageUrl (ustawiony powyżej)
        
        // 🎨 GALERIA: Zapisz generację do localStorage z base64 cache
        // ✅ DODAJ productType do generacji (dla skalowalności)
        const productType = this.getProductTypeFromStyle(this.selectedStyle);
        this.saveAIGeneration(
          base64,                     // Oryginalne zdjęcie (base64)
          result.transformedImage,    // AI obraz URL
          this.selectedStyle,         // Styl (pixar, boho, etc)
          this.selectedSize,         // Rozmiar (a4, a3, etc)
          productType,                // ✅ ProductType (boho, king, cats, etc)
          result.watermarkedImageUrl || this.watermarkedImageUrl || null, // ✅ ZAPISZ watermarkedImageUrl (Vercel Blob z watermarkiem)
          result.watermarkedImageBase64 || this.watermarkedImageBase64 || null, // ✅ NOWE: Base64 watermarku (dla /api/products - BEZ PONOWNEGO DOWNLOADU)
          this.artworkId || null
        ).then(() => {
          console.log('✅ [CACHE] AI generation saved with base64 cache');
          
          // ✅ KLUCZOWE: Pobierz zapisany generation z historii i użyj jego URL (z Vercel Blob)
          const generations = this.getAIGenerations();
          if (generations.length > 0) {
            const lastGeneration = generations[0];
            if (lastGeneration.transformedImage) {
              console.log('✅ [CACHE] Using saved URL from history:', lastGeneration.transformedImage.substring(0, 100));
              this.transformedImage = lastGeneration.transformedImage; // Użyj URL z Vercel Blob zamiast oryginału
              console.log('✅ [CACHE] Updated this.transformedImage to saved URL');
            }
          }
        }).catch(error => {
          console.error('❌ [CACHE] Failed to save AI generation:', error);
        });
        
        // Niezalogowani: inkrementuj licznik lokalny (zalogowani: backend API robi auto)
        if (!customerInfo) {
          this.incrementLocalUsage();
        }
      } else {
        this.showError('AI transformation failed: ' + (result.error || 'Unknown error'), 'transform');
      }
    } catch (error) {
      console.error('📱 [MOBILE] Transform error:', error);

      // Blad odczytu pliku (FileReader/arrayBuffer nie umie odczytac - e.g. Google Photos content URI)
      if (error?.name === 'FileReadError') {
        this.reportPhotoReadError(error, this.uploadedFile, 'transform');
        this.hideLoading();
        this.showError(error.message, 'transform');
        return;
      }

      // Retry logic for network errors (w tym "Error completing request", "Load failed" z Sentry)
      const isNetworkError = error?.message && (
        error.message.includes('Failed to fetch') ||
        error.message.includes('NetworkError') ||
        error.message.includes('Load failed') ||
        error.message.includes('Error completing request') ||
        error.message.includes('network failure')
      );
      if (isNetworkError || error.name === 'AbortError') {
        this._reportToSentry(error, 'transformImage_network', { retryCount, isAbort: error.name === 'AbortError' });
      } else {
        this._reportToSentry(error, 'transformImage');
      }
      if (retryCount < 3 && (error.name === 'AbortError' || isNetworkError)) {
        const retryDelay = (retryCount + 1) * 2000;
        console.log(`🔄 [MOBILE] Retrying in ${retryDelay}ms... (attempt ${retryCount + 1}/3)`);
        this.showError(`Network error - retrying ${retryCount + 1}/3...`, 'transform');
        setTimeout(() => {
          this.transformImage(retryCount + 1);
        }, retryDelay);
        return;
      }
      
      let errorMessage = 'Server connection failed';
      
      if (error.name === 'AbortError') {
        errorMessage = 'The request timed out (5 minutes). Try again.';
      } else if (error?.message && (error.message.includes('Failed to fetch') || error.message.includes('Error completing request') || error.message.includes('Load failed'))) {
        errorMessage = 'Network error. Check your internet connection and try again.';
      } else if (error?.message && error.message.includes('NetworkError')) {
        errorMessage = 'Network error. Try again shortly.';
      } else if (error?.message && error.message.includes('TypeError')) {
        errorMessage = 'Processing failed. Try again.';
      } else if (error?.message) {
        errorMessage = 'Error: ' + error.message;
      } else if (typeof error === 'string') {
        errorMessage = 'Error: ' + error;
      }
      
      this.showError(errorMessage, 'transform');
    } finally {
      this._familyPilotSnapshot = null;
      this.setFamilyPilotBusy(false);
      this.hideLoading();
    }
  },

  };
  const modernConfig = replacements.getCustomFieldConfig;
  replacements.getCustomFieldConfig = function () {
    const h = this.getProductHandle();
    if (h === 'bridesmaid-portrait-from-photos' || h === 'groomsmen-portrait-from-photos') return {
      multiUpload: true, minImages: 1, maxImages: 6, fields: [
        {id:'scena',label:'Describe the scene or mood',type:'text',placeholder:'e.g. garden wedding, coordinated outfits, bride or groom in the center'},
        {id:'dedykacja',label:'Signature or dedication (optional)',type:'text',placeholder:'e.g. Thank you for being by my side'}
      ]
    };
    return modernConfig.call(this) || previousConfig.call(this);
  };
  replacements.getProductLogicHandle = function () { return 'dodaj-osobe-do-zdjecia-naturalny-efekt-obraz-plakat-wydruk'; };
  Object.assign(proto, replacements);
})();
